import { Injectable } from '@angular/core';
import { CommonService } from "@services/utils/common.service";
import { ApiHelperService } from "@services/apihelper/api-helper.service";
import { PvRolName } from "@models/rol-name";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class RolNameService extends CommonService<PvRolName, string> {

  protected API_URL : string = `${environment.URL_API}/pvrolname`;

  constructor(http: ApiHelperService) {
    super(http);
  }
}
